<template>
  <div v-if="kinds.length" class="mt-3" data-test="role-scope">
    <label class="font-weight-bold d-block">{{ $t("organization.members.scope.title") }}</label>
    <small class="d-block text-muted mb-2">{{ $t("organization.members.scope.hint") }}</small>
    <!-- TKP-185 md.73: kapsam isteğe bağlı — sonradan birim/süreç ekranından da yetkilendirilebilir -->
    <small class="d-block text-muted mb-2" data-test="scope-optional">{{ $t("organization.members.scope.optional") }}</small>

    <div v-if="kinds.includes('department')" class="mb-2" data-test="scope-departments">
      <filter-select :key="'dep-' + organizationKey" :placeholder="$t('organization.members.scope.departments')" :multiple="true" :selected="value.scopeDepartments" @filter="onDepartmentSearch" @changed="(items) => update('scopeDepartments', items)" track="_id" />
    </div>
    <div v-if="kinds.includes('process')" data-test="scope-processes">
      <filter-select :key="'proc-' + organizationKey" :placeholder="$t('organization.members.scope.processes')" :multiple="true" :selected="value.scopeProcesses" @filter="onProcessSearch" @changed="(items) => update('scopeProcesses', items)" track="_id" />
    </div>
  </div>
</template>

<script>
import rest from "@/rest-client";
import { requiredScopeKinds, scopeHeaders } from "./member-roles";

/**
 * TKP-99 — "kapsamsız rol atanamaz": Birim / Süreç Yöneticisi rolü seçilince üyenin yetkilisi olacağı birim / süreçler buradan
 * seçilir. Yalnız EKLER; yetkili çıkarma birim ve süreç ekranlarında.
 */
export default {
  props: {
    roles: { type: Array, default: () => [] },
    value: { type: Object, default: () => ({ scopeDepartments: [], scopeProcesses: [] }) },
    /** TKP-185 md.74: hedef organizasyon (yönetici panelinden davet / yeni organizasyon) — liste onun birim/süreçlerinden; verilmezse seçili organizasyon. */
    organization: { type: Object, default: null },
  },
  computed: {
    kinds() {
      return requiredScopeKinds(this.roles);
    },
    /** TKP-202 n.6: kutular listelerini açılışta bir kez yükler — organizasyon değişince yeniden kurulurlar (önceki organizasyonun listesi kalmaz). */
    organizationKey() {
      const selected = this.$store && this.$store.getters ? this.$store.getters["organization/selected"] : null;
      return String((this.organization && this.organization._id) || (selected && selected._id) || "");
    },
  },
  methods: {
    update(field, items) {
      this.$emit("input", { ...this.value, [field]: items || [] });
    },
    /** Hedef organizasyon seçili organizasyondan farklıysa istek o organizasyonun başlığıyla gider (md.74: başka organizasyonun süreçleri listelenmesin). */
    async scopedSearch(path, value, callback) {
      const headers = scopeHeaders(this.organization, this.$store.getters["organization/selected"]);
      try {
        const response = await rest.post(path, { pagination: { options: { limit: 1000 }, query: { name: { value } } } }, headers ? { headers } : undefined);
        callback((response.data && response.data.docs) || []);
      } catch (error) {
        callback([]);
      }
    },
    onDepartmentSearch(value, callback) {
      return this.scopedSearch("/department/paginate", value, callback);
    },
    onProcessSearch(value, callback) {
      return this.scopedSearch("/department-process/paginate", value, callback);
    },
  },
};
</script>
